var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$route.meta.hasBackground !== false)?_c('el-image',{staticClass:"main__background-img",attrs:{"src":require('@/assets/images/background-xl.jpg')}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }